import React from 'react'
import Eula from '../eula'

const EulaDa = () => {
    return <Eula languageCode="da" />
}

export default EulaDa
